import {
  getCurrentProfileSelect,
  PLAN_KEY
} from '@gymaholic/packages'
import Button from 'components/Button'
import { LockIcon } from 'components/Icon/icons/lock'
import { OpenIcon } from 'components/Icon/icons/open'
import Text from 'components/Text'
import { View } from 'components/View'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import getImageUrlPlanUtil from 'modules/training/models/plan/utils/get-image-url'
import getNamePlanUtil from 'modules/training/models/plan/utils/get-name'
import getWeeksCountPlanUtil from 'modules/training/models/plan/utils/get-weeks-count'
import { getByIdTrainingPlanSelector } from 'modules/plan/redux/selectors'
import CircularProgress from 'pages/Creator/CircularProgress'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import pushRouterAction from 'modules/router/actions/push'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import Flex from 'components/Flex/index.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import getPathnamePlanUtil from 'modules/plan/redux/utils/get-pathname/index.js'
import PlanMediaImage from 'containers/Plan/PlanMediaImage/index.js'
import { IMAGE_ASPECT_RATIO_ID } from 'components/Image/constants/index.js'
import canEditPlanUtil from 'modules/plan/utils/can-edit/index.js'

const size = 135
const bgSize = size - 29
const bgSizePx = `${bgSize}px`

const ANALYTIC_EVENT = {
  VIEW_PLAN_CIRCLE: 'VIEW_PLAN_CIRCLE'
}

/**
 * @param props
 * @param props.isRecommended
 * @returns {JSX.Element}
 * @constructor
 */
const PlanCircle = (props) => {
  const {
    // index,
    style,
    // onClick,
    isSelected,
    dummyPlan,
    planId,
    isStarted,
    showOpenButton
  } = props
  const dispatch = useDispatch()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const plan = useSelector(
    getByIdTrainingPlanSelector((dummyPlan && dummyPlan.id) || planId)
  )
  const planName = getNamePlanUtil(plan) || (dummyPlan && dummyPlan.name)
  const planImage = getImageUrlPlanUtil(plan)
  const weeksCount = getWeeksCountPlanUtil(plan)
  const workoutsCompletedCount = getValueReduxUtil(plan, PLAN_KEY.WORKOUTS_COMPLETED_COUNT)
  const workoutsCount = getValueReduxUtil(plan, PLAN_KEY.WORKOUTS_COUNT)
  const percentageCompleted = (workoutsCompletedCount / workoutsCount) * 100
  const profile = useSelector(getCurrentProfileSelect)
  const canEdit = canEditPlanUtil(plan, profile)

  let progress
  const showProgress = isStarted || canEdit
  if (!showProgress || (
    dummyPlan && dummyPlan.id === 0
  )) {
    progress = 100
  } else {
    progress = percentageCompleted
  }

  const getWeekCountLabel = () => {
    if (weeksCount) {
      return `${weeksCount} weeks`
    }
    return 'no weeks'
  }

  const handleClickView = async () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.VIEW_PLAN_CIRCLE)

    const planPathname = getPathnamePlanUtil(plan)
    const planQuery = props.isRecommended
      ? ''
      : '?recommended=false'
    const pathname = `${planPathname}${planQuery}`

    dispatch(pushRouterAction({ pathname }))
  }

  const imageStyle = {
    width: bgSizePx,
    height: bgSizePx,
    borderRadius: '50%',
    objectFit: 'cover'
  }
  return (
    <Button
      style={{
        width: 'unset',
        height: 'unset',
        maxWidth: 'unset'
      }}
      onClick={handleClickView}
    >
      <Flex
        ac
        jc
        style={style}
      >
        <Text
          fs='0.87em'
          c='#151D21'
          style={{ opacity: weeksCount ? 1 : 0 }}
        >
          {getWeekCountLabel()}
        </Text>

        <View style={{ position: 'relative' }}>
          <CircularProgress
            progress={progress}
            width={size}
            disabled={
              !showProgress || (
                dummyPlan &&
                dummyPlan.id === 0
              )
            }
            isSelected={isSelected}
          />

          <View
            w={bgSizePx}
            h={bgSizePx}
            centered
            style={{
              borderRadius: '50%',
              position: 'absolute',
              left: 14.5,
              right: 0,
              top: 22
            }}
          >
            <PlanMediaImage
              id={planId}
              aspectRatio={IMAGE_ASPECT_RATIO_ID.SQUARE}
              fallbackImage={planImage}
              shouldDirectlyLoadTheSrcIfFallback
              style={imageStyle}
              imgStyle={imageStyle}
            />

            {
              isSelected &&
              showOpenButton && (
                <View
                  style={{
                    position: 'absolute'
                  }}
                >
                  <Button
                    onClick={handleClickView}
                    style={{
                      width: 'unset',
                      height: 'unset'
                    }}
                  >
                    <View
                      centered
                      w={bgSizePx}
                      h={bgSizePx}
                      bgc='rgba(28, 28, 30, 0.3)'
                      style={{
                        borderRadius: '50%'
                      }}
                    >
                      <OpenIcon
                        style={{
                          width: '32px',
                          height: '32px',
                          fill: '#ffffff'
                        }}
                      />
                    </View>
                  </Button>
                </View>
              )
            }

            {
              isSelected &&
              !showProgress &&
              dummyPlan &&
              dummyPlan.id !== 0 &&
              (
                <View
                  centered
                  w={bgSizePx}
                  h={bgSizePx}
                  bgc={showOpenButton ? 'unset' : 'rgba(28, 28, 30, 0.3)'}
                  style={{
                    position: 'absolute',
                    borderRadius: '50%'
                  }}
                >
                  <LockIcon
                    style={{
                      width: isSmallScreen
                        ? '22.03px'
                        : '10.78px',
                      height: '22px'
                    }}
                  />
                </View>
              )
            }
          </View>
        </View>

        <View ac>
          <Text
            fs='0.87em'
            c='#151D21'
            numberOfLines={2}
            style={{
              textAlign: 'center',
              width: '90%',
              lineHeight: '147.3%'
            }}
          >
            {planName}
          </Text>
        </View>
      </Flex>
    </Button>
  )
}

export default PlanCircle
